/*
 * massage-session (zod)
 */
import { createInsertSchema, createSelectSchema } from "drizzle-zod"
import * as z from "zod"
import { globalCreateExclude, globalUpdateExclude } from "../utils/constants"
import { massageSessions } from "./massage-session.schema"

export type MassageSession = z.infer<typeof selectMassageSessionSchema>
export const selectMassageSessionSchema = createSelectSchema(massageSessions)

export type MassageSessionFilters = z.infer<typeof massageSessionFiltersSchema>
export const massageSessionFiltersSchema = z.object({
	id:          z.string().optional(),
	patientId:   z.string().optional(),
	therapistId: z.string().optional(),
	sessionDate: z.string().optional(),
	active:      z.boolean().optional(),
})

export const createMassageSessionSchema = createInsertSchema(massageSessions)
	.partial(globalCreateExclude)
export type CreateMassageSession = z.infer<typeof createMassageSessionSchema>

export const updateMassageSessionSchema = createInsertSchema(massageSessions)
	.omit(globalUpdateExclude)
	.partial()
	.required({ id: true })
export type UpdateMassageSession = z.infer<typeof updateMassageSessionSchema>
